import { render, staticRenderFns } from "./BeastFooter.vue?vue&type=template&id=7082d9f4&scoped=true"
import script from "./BeastFooter.vue?vue&type=script&lang=js"
export * from "./BeastFooter.vue?vue&type=script&lang=js"
import style0 from "./BeastFooter.vue?vue&type=style&index=0&id=7082d9f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7082d9f4",
  null
  
)

export default component.exports